
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.534 14.034h-.79l-.28-.27a6.518 6.518 0 10-.7.7l.27.28v.79l4.26 4.25a1.044 1.044 0 001.48 0l.01-.01a1.044 1.044 0 000-1.48l-4.25-4.26zm-6 0a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2-5h4a.5.5 0 110 1h-4a.5.5 0 110-1z"}})])
          )
        }
      }
    